import type { CellContext } from '@tanstack/react-table'

import { HighlightText } from '@/components/ui/table/DataTable/HighlightText'
import type { Transaction } from '@/modules/projects'
import { numberToCurrency } from '@/utils'

export const AmountCell = (cell: CellContext<Transaction, number>) => {
  const amount = cell.getValue()
  const isNegative = amount < 0
  const searchQuery = cell.table.options.meta?.searchQuery
  const formatted = numberToCurrency(amount)

  return (
    <span
      className={`block truncate font-normal ${isNegative ? 'text-red-600' : 'text-emerald-500'}`}
    >
      <HighlightText text={formatted} query={searchQuery} />
    </span>
  )
}
